export default __webpack_public_path__ + "static/media/u1.601075f7.jfif";